import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import { servicesPageQuery } from '../queries';

const Services = () => {
  // Default content to show immediately (no loading state)
  const defaultData = {
    title: "Services",
    subtitle: "Great lifestyle, exceptional care",
    introText: "Tandara's well qualified and caring staff ensure that residents receive the best possible care at all times. Meals prepared in the top quality kitchen are varied and residents have input into changes to menus. Residents are able to enjoy a varied range of activities including crafts, music, cooking, relaxed sports, exercising and trips in our bus. Regular entertainment events are organised though out the year.\n\nA recent addition has been a gymnasium which houses state of the art equipment and permits exercise and rehabilitation options.\n\nResidents also have access to a variety of computer equipment (internet access) and electronic entertainment systems."
  };

  return (
    <StaticPageTemplate
      pageName="servicesPage"
      query={servicesPageQuery}
      defaultData={defaultData}
    />
  );
};

export default Services;
